import { Component, computed, inject } from '@angular/core';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { AppStore } from '@app/stores/app/app.store';

@Component({
    selector: 'app-busy-progress',
    imports: [MatProgressBarModule],
    templateUrl: './busy-progress.component.html',
    styleUrls: ['./busy-progress.component.scss'],
})
export class BusyProgressComponent {
    private appStore = inject(AppStore);
    isBusy = computed(() => this.appStore.isBusy());
}
